
import Tabs from "../functions/tabs"

if (document.querySelector('.partners')) {
  new Tabs('.partners').renderTab();
}
